<div class="item">
  <span>Name: </span> <span>{{profile?.fname}} {{profile?.lname}}</span>
</div>
<div class="item"><span>Email: </span> <span>{{profile?.email}}</span></div>
